'use strict';

var React = require('react/addons');
var Reflux = require('reflux');

var _require = require('react-router');

var Navigation = _require.Navigation;

/* Stores */
var LanguageStore = require('stores/language');
var TeamStore = require('stores/team');
var UserStore = require('stores/user');
var ProjectStore = require('stores/project');
var DatasourceStore = require('stores/datasource');
var AuthenticationStore = require('stores/authentication');

/* Mixins */
var AuthenticationMixin = require('mixins/authentication');

/* Actions */
var TeamActions = require('actions/team');
var UserActions = require('actions/user');
var ProjectActions = require('actions/project');
var DatasourceActions = require('actions/datasource');

/* Components */
var Panel = require('./ui/panel');
var TeamList = require('./team/list');
var UserList = require('./user/list');
var ProjectList = require('./project/list');
var DatasourceList = require('./datasource/list');

var TeamDetails = require('./team/details');
var UserDetails = require('./user/details');
var ProjectDetails = require('./project/details');
var DatasourceDetails = require('./datasource/details');

var Dashboard = React.createClass({
  displayName: 'Dashboard',

  mixins: [Navigation, AuthenticationMixin, Reflux.connect(TeamStore, 'teams'), Reflux.connect(UserStore, 'users'), Reflux.connect(ProjectStore, 'projects'), Reflux.connect(DatasourceStore, 'datasources')],
  componentDidMount: function componentDidMount() {
    TeamActions.loadAll();
    UserActions.loadAll();
    ProjectActions.loadAll();
    DatasourceActions.loadAll();
  },
  render: function render() {
    var component = this;
    var params = component.props.params;
    var id = params.id;
    var type = params.type;

    var cx = React.addons.classSet;

    /* Lists */
    var teams = component.state.teams;
    var users = component.state.users;
    var projects = component.state.projects;
    var datasources = component.state.datasources;

    if (TeamStore.loading || UserStore.loading || ProjectStore.loading || DatasourceStore.loading) {
      return null;
    }

    /* Nodes */
    var teamNode = React.createElement(TeamList, { teams: teams, onSelect: this.onSelect.bind(null, 'team'), onCreate: this.onCreate.bind(null, 'team') });
    var userNode = React.createElement(UserList, { users: users, onSelect: this.onSelect.bind(null, 'user'), onCreate: this.onCreate.bind(null, 'user') });
    var projectNode = React.createElement(ProjectList, { projects: projects, onSelect: this.onSelect.bind(null, 'project'), onCreate: this.onCreate.bind(null, 'project') });
    var datasourceNode = React.createElement(DatasourceList, { datasources: datasources, onSelect: this.onSelect.bind(null, 'datasource'), onCreate: this.onCreate.bind(null, 'datasource') });

    var teamSelected = false;
    var userSelected = false;
    var projectSelected = false;
    var datasourceSelected = false;

    var teamErrors = TeamStore.errors;
    var userErrors = UserStore.errors;
    var projectErrors = ProjectStore.errors;
    var datasourceErrors = DatasourceStore.errors;

    var item = null;
    var create = id === undefined;
    var edit = !create;

    /* State */
    switch (type) {
      case 'user':
        {
          if (edit) {
            item = users.find(function (item) {
              return item.id === id;
            });
          }
          userNode = React.createElement(UserDetails, { create: create, busy: UserStore.busy, user: item, errors: userErrors });
          userSelected = true;
          break;
        }
      case 'team':
        {
          if (edit) {
            item = teams.find(function (item) {
              return item.id === id;
            });
          }
          teamNode = React.createElement(TeamDetails, { create: create, busy: TeamStore.busy, team: item, errors: teamErrors });
          teamSelected = true;
          break;
        }
      case 'project':
        {
          if (edit) {
            item = projects.find(function (item) {
              return item.id === id;
            });
          }
          projectNode = React.createElement(ProjectDetails, { create: create, busy: ProjectStore.busy, project: item, errors: projectErrors });
          projectSelected = true;
          break;
        }
      case 'datasource':
        {
          if (edit) {
            item = datasources.find(function (item) {
              return item.id === id;
            });
          }
          datasourceNode = React.createElement(DatasourceDetails, { create: create, busy: DatasourceStore.busy, datasource: item, errors: datasourceErrors });
          datasourceSelected = true;
          break;
        }
    }

    /* Selection */
    var teamClasses = { selected: teamSelected };
    var userClasses = { selected: userSelected };
    var projectClasses = { selected: projectSelected };
    var datasourceClasses = { selected: datasourceSelected };

    /* Translations */
    var translate = LanguageStore.translate;
    var logoutText = translate('log_out');

    /* Logout menu */
    var logoutNode = null;

    if (AuthenticationStore.loggedIn) {
      logoutNode = React.createElement(
        'div',
        { className: 'logout-component link', onClick: component._onLogoutClick },
        logoutText
      );
    }

    return React.createElement(
      'div',
      { className: 'dashboard-component' },
      logoutNode,
      React.createElement(
        Panel,
        { className: cx(teamClasses) },
        teamNode
      ),
      React.createElement(
        Panel,
        { className: cx(userClasses) },
        userNode
      ),
      React.createElement(
        Panel,
        { className: cx(projectClasses) },
        projectNode
      ),
      React.createElement(
        Panel,
        { className: cx(datasourceClasses) },
        datasourceNode
      )
    );
  },

  onSelect: function onSelect(name, id) {
    this.transitionTo('/' + name + '/' + id);
  },

  onCreate: function onCreate(name) {
    this.transitionTo('/' + name + '/new');
  },

  _onLogoutClick: function _onLogoutClick() {
    window.location = '/logout';
  }
});

module.exports = Dashboard;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/dashboard.js
 **/